import React from 'react'
import './loading.css'
const Loading = () => {
    return (
        <div className="container">
            <div className="ball">
                <div className="button"></div>
            </div>
        </div>
    )
}

export default Loading;